export default "__VITE_ASSET__370f3b86__"